<template>
  <mobile-only-bottom-sheet :value="value" max-width="455">
    <v-sheet>
      <v-container class="pt-0">
        <v-row justify="end">
          <v-col cols="12" class="text-h6 text-center">
            {{ $t("BUY_THIS_CARD") }}
            <v-btn class="float-right" icon @click="$emit('input', false)">
              <v-icon>
                {{ mdiWindowClose }}
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="6" md="5" class="pr-0">
            <v-img :src="templateDetails.thumbnail"></v-img>
          </v-col>
          <!--  card benefits list  -->
          <v-col cols="6" md="7">
            <v-row dense>
              <v-col class="pt-0 text-subtitle-1 black--text">
                {{ $t("HERES_WHAT_YOU_GET") }}
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="auto">
                <v-icon small color="primary">{{ mdiCheck }}</v-icon>
              </v-col>
              <v-col class="text--secondary text-body-2">
                {{ $t("High_Quality_Ecard_PDF_Image") }}
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="auto">
                <v-icon small color="primary">{{ mdiCheck }}</v-icon>
              </v-col>
              <v-col class="text--secondary text-body-2">
                {{ $t("Invite_all_your_Friends_N_Relatives") }}
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="auto">
                <v-icon small color="primary">{{ mdiCheck }}</v-icon>
              </v-col>
              <v-col class="text--secondary text-body-2">
                {{ $t("You_can_use_the_design_for_printing_Purposes") }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row dense justify="center">
          <v-col v-if="templateDetails" class="text-center">
            {{ $t("CARD_PRICE") }}
            <span class="primary--text">
              {{ templateDetails.currency_symbol }}
              {{ templateDetails.price_android_discounted }}
            </span>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col v-if="templateDetails" class="mx-3 text-center">
            <v-btn
              block
              color="primary"
              rounded
              :loading="paymentGatewayLoading"
              @click.native="pay"
            >
              <span>
                {{ $t("PAY_NOW_N_DOWNLOAD") }}
              </span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row dense class="text-center">
          <v-col class="text-caption">
            {{ $t("NEED_HELP_CALL_US") }}:
            <a
              class="text--secondary"
              :href="`tel:${$store.state.support_contact}`"
            >
              {{ $store.state.support_contact }}
            </a>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </mobile-only-bottom-sheet>
</template>

<script>
import { mdiCheck, mdiWindowClose } from "@mdi/js";
import { loadStripe } from "@stripe/stripe-js/pure";
import MobileOnlyBottomSheet from "@/components/MobileOnlyBottomSheet";

export default {
  components: {
    MobileOnlyBottomSheet
  },

  props: {
    templateDetails: {
      type: Object,
      required: true
    },

    cardId: {
      type: Number,
      required: true
    },

    cardType: {
      type: String,
      required: true
    },

    value: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      mdiCheck,
      mdiWindowClose,
      paymentGatewayLoading: false
    };
  },

  methods: {
    async pay() {
      this.logFirebaseEvent("click_payment_buy_now");
      this.paymentGatewayLoading = true;
      const paymentData = await this.fetchPaymentDetails();

      const payment_gateway = paymentData.payment_gateway;
      if (payment_gateway === "stripe") {
        localStorage.setItem("transaction_id", paymentData.transaction_id);
        const stripe = await loadStripe(paymentData.payment_gateway_key);
        return stripe.redirectToCheckout({
          sessionId: paymentData.payment_gateway_order_id
        });
      } else {
        const options = this.getRazorpayOptions();
        options.key = paymentData.payment_gateway_key;
        options.order_id = paymentData.payment_gateway_order_id;
        options.amount = paymentData.price_discounted * 100;
        options.currency = paymentData.currency_code;
        options.handler = this.razorpayPaymentHandler;
        const rzp = new window.Razorpay(options);
        rzp.open();
      }

      this.paymentGatewayLoading = false;
    },

    async razorpayPaymentHandler(razorpayPayment) {
      const fd = new FormData();
      fd.append("razorpay_payment_id", razorpayPayment.razorpay_payment_id);
      fd.append("razorpay_order_id", razorpayPayment.razorpay_order_id);
      fd.append("razorpay_signature", razorpayPayment.razorpay_signature);

      await this.$axios.post("/payment/razorpay/verify-payment/", fd);
      this.$emit("payment");
    },

    async fetchPaymentDetails() {
      const params = {
        cardType: this.cardType,
        card_table_id: this.cardId
      };
      const response = await this.$axios.get("/payment/initiate_payment/", {
        params
      });
      return response.data;
    }
  }
};
</script>

<style lang="sass" scoped>
.card-html-preview
  max-width: 175px
  max-height: 230px
  padding: 0
  overflow: hidden


.card-html-preview__wrapper
  width: 600px
  height: 930px
  overflow-y: hidden
  transform: scale(0.25)
  transform-origin: 0 0


.card-html-preview__wrapper__iframe
  width: 100%
  height: 100%
  border: 0
</style>
